import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAdmin } from '../../utils/useIsAdmin';
import { useAuth } from '../../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactElement;
}

/**
 * Route protection component that only allows admin users to access the route
 * Non-admin users are redirected to the dashboard
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isLoading } = useAuth();
  const isAdmin = useIsAdmin();

  if (isLoading) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;

